import { useRef, forwardRef, useImperativeHandle } from "react";
import { LoadingSvg } from "../../icons/Icon";
import { Loading } from "../Loaders";
import InputWrapper from "../components/InputWrapper";
import { SelectOptionsSection } from "../../widgets/MultiSelectOptions";
import MyQuillEditor from "../../widgets/MyQuillEditor";
import { useEventContext } from "../../contexts/EventContextProvider";
import { DISCOUNT_CREATE_EDIT_FORM_CANCEL } from "../../events/actions/DiscountActions";
import { iconsMap } from "../../icons/iconsMap";
import { saveDiscountEvent } from "../../events/DiscountEvents";

const DiscountCouponInputBar = forwardRef((p, r) => {

    const { state, eventDispatch } = useEventContext();
    const form = useRef(null);

    useImperativeHandle(r, () => ({
        getForm: () => form.current
    }));
    const actionClass = {
        edit: 'CollectionInputBar_controls_edit',
        save: 'CollectionInputBar_controls_edit',
        create: 'CollectionInputBar_controls_create',
        delete: 'CollectionInputBar_controls_delete',
    };

    const onCancel = (e) => {
        eventDispatch(DISCOUNT_CREATE_EDIT_FORM_CANCEL());
    };
    const onSave = (e) => {
        eventDispatch(saveDiscountEvent(form));
    };
    const onDelete = (e, o) => {
        e.preventDefault();
    };
    const onCombinableChange = () => {
        //console.log('onCombinableChange');
    };
    const renderCase = (state, render) => {
        switch (state?.status) {
            case 'LOADING':
                return <Loading><LoadingSvg /></Loading>;
            case 'DONE':
                return render({...state.payload, meta: state.meta});
            case 'ERROR':
                return <></>;
            default:
                return <></>;
        }
    }
    const render = (p) => {
        return (
            <div className="CollectionInputBar">
                <div className="CollectionInputBar_header">
                    <h6 className="CollectionInputBar_title">
                        {iconsMap[p.meta.type]}<span>{p?.meta?.title || ''}</span>
                        <em>{p?.name || ''}</em>
                    </h6>
                    <div className="CollectionInputBar_controls">
                        <button onClick={onCancel} className="CollectionInputBar_controls_cancel">cancel</button>
                        {(p?.meta?.button) ?
                            <button onClick={onSave} className={actionClass[p.meta.type]} >{p.meta.button}</button> :
                            <></>}
                    </div>
                </div>
                <form ref={form}>
                    <div className="CollectionInputBar_body">
                        <div className="flex-column">
                            <div className="flex-row">
                                <input type="hidden" name="id" defaultValue={p.id || ''} />
                                <div className="col-6">
                                    <InputWrapper label={'name'}>
                                        <input type="text" id="name" name="name" maxLength="256" defaultValue={p.name} required />
                                    </InputWrapper>
                                </div>
                                <div className="col-6">
                                    <InputWrapper label={'code'}>
                                        <input type="text" id="code" name="code" maxLength="256" defaultValue={p.code} required />
                                    </InputWrapper>
                                </div>
                                <div className="col-6">
                                    <InputWrapper label={'percentage'}>
                                        <input type="number" id="percentage" name="percentage" min="0" max="100" defaultValue={p.percentage} />
                                    </InputWrapper>
                                </div>
                                <div className="col-6">
                                    <InputWrapper label={'amount'}>
                                        <input type="number" id="amount" name="amount" min="0" defaultValue={p.amount} />
                                    </InputWrapper>
                                </div>
                            </div>
                            <div className="flex-row">
                                <div className="col-12">
                                    <InputWrapper label={'url'}>
                                        <input type="url" id="url" name="url" maxLength="256" defaultValue={p.url} />
                                    </InputWrapper>
                                </div>
                                <div className="col-4">
                                    <InputWrapper label={'min order value'}>
                                        <input type="number" id="minimumOrderValue" name="minimumOrderValue" min="0" defaultValue={p.minimumOrderValue} />
                                    </InputWrapper>
                                </div>
                                <div className="col-4">
                                    <InputWrapper label={'unit cap'}>
                                        <input type="number" id="usageCap" name="usageCap" min="0" defaultValue={p.usageCap} />
                                    </InputWrapper>
                                </div>
                                <div className="col-4">
                                    <InputWrapper label={'cap per user'}>
                                        <input type="number" id="usageCapPerUser" name="usageCapPerUser" min="0" defaultValue={p.usageCapPerUser} />
                                    </InputWrapper>
                                </div>
                            </div>
                            <div className="flex-row">
                                <div className="col-8">
                                    <InputWrapper label={'combinable'}>
                                        <SelectOptionsSection
                                            name='combinable'
                                            multiple={false}
                                            options={[{ value: 1, label: 'true' }, { value: 0, label: 'false' }]}
                                            selected={(p.combinable) ? [{ value: 1, label: 'true' }] : [{ value: 0, label: 'false' }]}
                                            onChange={onCombinableChange}
                                            className={''}
                                        />
                                    </InputWrapper>
                                </div>
                                <div className="col-8">
                                    <InputWrapper label={'active'}>
                                        <SelectOptionsSection
                                            name='active'
                                            multiple={false}
                                            options={[{ value: 1, label: 'true' }, { value: 0, label: 'false' }]}
                                            selected={(p.active) ? [{ value: 1, label: 'true' }] : [{ value: 0, label: 'false' }]}
                                            onChange={onCombinableChange}
                                            className={''}
                                        />
                                    </InputWrapper>
                                </div>
                                <div className="col-8">
                                    <InputWrapper label={'expiry date'}>
                                        <input type="datetime-local" id="expiryDate" name="expiryDate" defaultValue={p.expiryDate} />
                                    </InputWrapper>
                                </div>
                            </div>
                            <div className="flex-row">
                                <div className="col-24">
                                    <InputWrapper label={'description'}>
                                        <MyQuillEditor
                                            value={p.description || ''}
                                            name="description"
                                            onChange={(e) => console.log(e)}
                                            style={{ height: '', boxSizing: 'border-box', backgroundColor: '#ffffff' }}
                                        />
                                    </InputWrapper>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
    return renderCase(state.discountCreateEdit, render);
});

export default DiscountCouponInputBar;
